import { Reimbursement } from '~/Api/Analytics/VirtualBrand/Reimbursement';

import ActionTypes from './ActionTypes';

export interface ReimbursementState {
	request: Promise<any>;
	isFething: boolean;
	items: Reimbursement[] | null;
}

export interface State {
	byId: { [key: string]: ReimbursementState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			id: string;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			id: string;
			items: Reimbursement[];
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			id: string;
			items: null;
	  }
	| {
			type: ActionTypes.pruneAll;
	  };

function createState(): State {
	return {
		byId: {},
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byId: {
					...state.byId,
					[action.id]: {
						request: action.request,
						isFething: true,
						items: null,
					},
				},
			};

		case ActionTypes.receive: {
			const reimbursementState = state.byId[action.id];
			if (reimbursementState.request !== action.request) {
				return state;
			}
			if (!action.items) {
				const byId = { ...state.byId };
				delete byId[action.id];
				return { ...state, byId };
			}

			return {
				...state,
				byId: {
					...state.byId,
					[action.id]: {
						...reimbursementState,
						isFething: false,
						items: action.items,
					},
				},
			};
		}

		case ActionTypes.pruneAll:
			return createState();

		default:
			return state;
	}
}

export function selectReimbursementById(state: State, id: string): ReimbursementState | null {
	return state.byId[id] || null;
}
